import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Types.Person.Phone
 * 
 * Endpoints: /api/v2/versicherungen/fahrrad/anlage, /api/Identity, /api/Kommunikation, /api/Kommunikation/update, /api/MeineDaten/Update, /api/mitgliedschaft, /api/versicherungen/us/pruefen
 */
export class PhoneApi extends BaseApiModel {
	constructor(initialProperties?: Partial<PhoneApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected country: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Country(): string {
		return this.country;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Country(value: string) {
		this.country = value;
	}

	protected prefix: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Prefix(): string {
		return this.prefix;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Prefix(value: string) {
		this.prefix = value;
	}

	protected suffix: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Suffix(): string {
		return this.suffix;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Suffix(value: string) {
		this.suffix = value;
	}

	protected extension: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Extension(): string {
		return this.extension;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Extension(value: string) {
		this.extension = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PhoneApi {
		return AppUtils.Helper.createFromMap(dataObject, PhoneApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Country = this.country;
		result.Prefix = this.prefix;
		result.Suffix = this.suffix;
		result.Extension = this.extension;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}